// extracted by mini-css-extract-plugin
export default {"tooltip":"QU-z","arrow":"RU-z"};